import React, {ChangeEvent, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {DO_OR_NOT, SEX_MASTER} from '../../../CodeMaster'
import NatResidentUserRepo, {UpdateResidentUserLoginedRequest} from './repository/NatResidentUserRepo'
import styled from 'styled-components'
import {Colors, FontSize} from '../../../styledComponents/Constants'
import {
    DisplayCheckItemSelectionLabel,
    DisplayCheckItemSelectionName,
    DisplayItemInputTitleNoMargin,
} from '../../../styledComponents/DisplayItem'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {Box, Checkbox, Link} from '@mui/material'
import {formatDateZeroPadding} from '../../../formatters/formatDate'
import {Messages} from '../../../Messages'
import NatResidentApplicationDetailFormItem from '../applications/common/resident/NatResidentApplicationDetailFormItem'
import {ColumnFlexContainer, FlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {PPTextFieldForResident} from '../../../components/shared/forms/resident/PPTextFieldForResident'
import {
    BlockSpacer,
    BlockSpacerSpOnly,
    currentMedia,
    GridItem,
    LabeledGridContainer,
} from '../../../styledComponents/ResponsiveConvenience'
import {
    ListGridContainer,
    PageTitle,
    WideWhiteArea,
} from '../applications/common/resident/NatResidentApplicationsCommon'
import {
    HeadingAreaMessageComponentForResident,
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {OpenInNew} from '@mui/icons-material'
import {HKConstants} from '../../../HKConstants'
import {NatGetResidentUserAuthed} from './repository/NatGetResidentUserAuthed'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

const LOGIN_USER_MAIL_ADDRESS_DOMAIN: string = 'loginUserMailAddressDomain'

interface Props {
    residentUserRepo: NatResidentUserRepo
    location: Location
}

interface States {
    wishToHasekoGroupInfos: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    mailAddress: string
    birthday: string
    sex: string
    version: number
    applyButtonDisabled: boolean
    policyChecked: boolean
    isLoadCompleted: boolean
}

class NatResidentHasekoIdRegistrationPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, States> {
    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)
        this.state = {
            wishToHasekoGroupInfos: DO_OR_NOT.DO.value,
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            mailAddress: '',
            birthday: '',
            sex: '',
            version: 0,
            applyButtonDisabled: true,
            policyChecked: false,
            isLoadCompleted: false,
        }

        this.onChangeWishToHasekoGroupInfos = this.onChangeWishToHasekoGroupInfos.bind(this)
        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.registerButtonClick = this.registerButtonClick.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.notRegistrationButtonClick = this.notRegistrationButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 居住者ユーザ取得（ログイン済）
            const retResidentUser: Nullable<NatGetResidentUserAuthed> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserLogined.bind(
                    this.props.residentUserRepo), this.props.navigate)
            if (retResidentUser && retResidentUser.details !== null) {
                this.setState({
                    familyName: retResidentUser.details.familyName,
                    firstName: retResidentUser.details.firstName,
                    familyNameKana: retResidentUser.details.familyNameKana,
                    firstNameKana: retResidentUser.details.firstNameKana,
                    birthday: formatDateZeroPadding(retResidentUser.details.birthday),
                    sex: SEX_MASTER.codeToEnumConstants(retResidentUser.details.sex).label,
                    version: retResidentUser.details.version,
                    isLoadCompleted: true,
                })
                const loginUserMailAddressDomain: string | null =
                    window.sessionStorage.getItem(LOGIN_USER_MAIL_ADDRESS_DOMAIN)
                if (loginUserMailAddressDomain) {
                    if (loginUserMailAddressDomain === retResidentUser.details.mailAddressPc.split('@')[1]) {
                        this.setState({mailAddress: retResidentUser.details.mailAddressPc})
                    } else if (loginUserMailAddressDomain === retResidentUser.details.mailAddressMb.split('@')[1]) {
                        this.setState({mailAddress: retResidentUser.details.mailAddressMb})
                    }
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeWishToHasekoGroupInfos(event: React.ChangeEvent<HTMLInputElement>): void {
        const checked = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
        this.setState({wishToHasekoGroupInfos: checked})
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            policyChecked: event.target.checked,
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof States
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            familyName, firstName, familyNameKana, firstNameKana, policyChecked,
        } = this.state

        let applyButtonDisabled = false
        if (!familyName || !firstName || !familyNameKana || !firstNameKana || !policyChecked) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    // あとで登録する
    async notRegistrationButtonClick(): Promise<void> {
        this.props.navigate('/resident/mypage')
    }

    // 氏名入力項目
    renderNameInput(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <NatResidentApplicationDetailFormItem
                    title={'氏名'}
                    required
                    component={
                        <FlexContainer>
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'familyName',
                                    maxLength: 10,
                                    value: this.state.familyName,
                                    onChange: this.handleChangeText,
                                    placeholder: '例：素敵',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['familyName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                            <FlexContainer>
                                <BlockSpacer width={5}/>
                            </FlexContainer>
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'firstName',
                                    maxLength: 10,
                                    value: this.state.firstName,
                                    placeholder: '例：太郎',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['firstName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </FlexContainer>
                    }
                />
                <Box height={'20px'}/>
                <NatResidentApplicationDetailFormItem
                    title={'フリガナ'}
                    required
                    component={
                        <FlexContainer>
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'familyNameKana',
                                    maxLength: 20,
                                    value: this.state.familyNameKana,
                                    onChange: this.handleChangeText,
                                    placeholder: '例：ステキ',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['familyNameKana']}
                                eventEmitter={this.props.eventEmitter}
                            />
                            <FlexContainer>
                                <BlockSpacer width={5}/>
                            </FlexContainer>
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'firstNameKana',
                                    maxLength: 20,
                                    value: this.state.firstNameKana,
                                    placeholder: '例：タロウ',
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['firstNameKana']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </FlexContainer>
                    }
                />
            </>
        )
    }

    // ユーザ情報項目
    renderUserInfo(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <LabeledGridContainer>
                    <GridItem over={3}>
                        {<DisplayItemInputTitleNoMargin>メールアドレス</DisplayItemInputTitleNoMargin>}
                    </GridItem>
                    <GridItem over={9}>
                        <BlockSpacerSpOnly height={'10px'}/>
                        {this.state.mailAddress}
                    </GridItem>
                </LabeledGridContainer>
                <Box height={'20px'}/>
                <LabeledGridContainer>
                    <GridItem over={3}>
                        {<DisplayItemInputTitleNoMargin>生年月日</DisplayItemInputTitleNoMargin>}
                    </GridItem>
                    <GridItem over={9}>
                        <BlockSpacerSpOnly height={'10px'}/>
                        {this.state.birthday}
                    </GridItem>
                </LabeledGridContainer>
                <Box height={'20px'}/>
                <LabeledGridContainer>
                    <GridItem over={3}>
                        {<DisplayItemInputTitleNoMargin>性別</DisplayItemInputTitleNoMargin>}
                    </GridItem>
                    <GridItem over={9}>
                        <BlockSpacerSpOnly height={'10px'}/>
                        {this.state.sex}
                    </GridItem>
                </LabeledGridContainer>
            </>
        )
    }

    // 利用規約
    renderConfirmMassage(): ReactElement {
        return (
            <Box>
                登録には、
                <Link
                    href={HKConstants.CMN.OPC.HASEKO_ID_USE_AGREEMENT_URL}
                    style={{textDecoration: 'none', color: Colors.Primary}}
                    target={'_blank'}
                    underline="hover">
                    長谷工ID利用規約<OpenInNew style={openInNewIconStyle}/>
                </Link>
                への同意が必要です。
                <Box height={'20px'}/>
                <ColumnFlexContainer>
                    <DisplayCheckItemSelectionLabel>
                        <DisplayCheckItemSelectionName>
                            <input
                                type="checkbox"
                                checked={this.state.policyChecked}
                                onChange={this.onChangePolicyChecked}
                            />
                            <span style={{marginLeft: '10px'}}>「長谷工ID利用規約」に同意する</span>
                        </DisplayCheckItemSelectionName>
                    </DisplayCheckItemSelectionLabel>
                </ColumnFlexContainer>
            </Box>
        )
    }

    // メールマガジン設定
    renderwishToHasekoGroupInfosInput(): Nullable<ReactElement> {
        return (
            <>
                <Box height={'15px'}/>
                <Box>メールマガジン配信希望</Box>
                <Box height={'5px'}/>
                <InfosWhiteArea>
                    <Box height={'10px'}/>
                    <LeftRowFlexContainer>
                        <Checkbox
                            name="wishToHasekoGroupInfos"
                            color="default"
                            checked={(this.state.wishToHasekoGroupInfos !== DO_OR_NOT.NOT.value)}
                            onChange={this.onChangeWishToHasekoGroupInfos}
                        />
                        長谷工グループ「ブランシエラクラブ」
                    </LeftRowFlexContainer>
                    <InfosContainer>
                        長谷工グループからのお得情報、住まいに関する情報をお届けいたします。
                        （特典、住まいレージポイントサービス、イベント、その他お得なお知らせなど）
                    </InfosContainer>
                    <Box height={'15px'}/>
                    <Box padding={'0 9px'} fontSize={FontSize.Small} color={Colors.AccentDark}>
                        ※メールマガジン内のリンクよりいつでも配信停止できます。
                    </Box>
                    <Box height={'15px'}/>
                </InfosWhiteArea>
            </>
        )
    }

    renderHasekoIdNotificationNote(): Nullable<ReactElement> {
        return (
            <ListGridContainer fontSize={FontSize.Small}>
                <div>・</div>
                <div>
                    長谷工IDに関するお知らせ及び、長谷工グループ「ブランシエラクラブ」のメールマガジンは、@haseko.co.jpより配信されます。
                </div>
                <div>・</div>
                <div>
                    プロバイダやメールソフトの設定などにより、受信ができない場合がございます。
                </div>
                <div>・</div>
                <div>
                    上記メールが受信できるように、迷惑メール設定・ドメイン指定受信の設定をお願いいたします。
                </div>
            </ListGridContainer>
        )
    }

    // 登録する
    async registerButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 居住者ユーザ更新（ログイン済）
            const request: UpdateResidentUserLoginedRequest = {
                familyName: this.state.familyName,
                firstName: this.state.firstName,
                familyNameKana: this.state.familyNameKana,
                firstNameKana: this.state.firstNameKana,
                homeMileageLinkGuideDisplay: DO_OR_NOT.NOT.value,
                accessControlDiv: DO_OR_NOT.DO.value,
                wishToHasekoGroupInfos: this.state.wishToHasekoGroupInfos,
                version: this.state.version,
            }
            const response: Nullable<void> = await this.props.asyncCallFunction(
                this.props.residentUserRepo.updateResidentUserLogined.bind(
                    this.props.residentUserRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {
                    defaultErrorTitle: Messages.EOPCR0014.toString(),
                    defaultErrorTitlePriority: true,
                    replacementDetailErrorMessages: [{
                        targetMessageId: Messages.EOPCA0004,
                        replacementMessageId: Messages.EOPCR0015,
                    }],
                },
            )
            if (response) {
                // セッションストレージ更新
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageByKey(
                    ResidentLoginInfoSessionStorageKey.LOGIN_FAMILY_NAME,
                    this.state.familyName)
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageByKey(
                    ResidentLoginInfoSessionStorageKey.LOGIN_FIRST_NAME,
                    this.state.firstName)

                this.props.navigate(`/resident/hasekoIdLinkComplete`)
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return <>
            <Box height={'15px'}/>
            <PageTitle>
                長谷工ID登録
            </PageTitle>
            <Box height={'20px'}/>
            <HeadingAreaMessageComponentForResident eventEmitter={this.props.eventEmitter}/>
            <Box>
                以下の内容で、長谷工IDへの登録を行います。<br/>
                メールアドレスは、
                <Link
                    onClick={() => this.props.navigate(
                        `/resident/personalSetting`,
                    )}
                    style={{textDecoration: 'none', cursor: 'pointer', color: Colors.Primary}}
                    underline="hover">
                    個人設定メニュー
                </Link>
                より修正いただけます。
            </Box>
            <Box height={'10px'}/>
            <WideWhiteArea>
                {this.renderNameInput()}
                {this.renderUserInfo()}
                <Box height={'15px'}/>
            </WideWhiteArea>
            {this.renderwishToHasekoGroupInfosInput()}
            <Box height={'15px'}/>
            {this.renderConfirmMassage()}
            <Box height={'30px'}/>
            <PrimaryStyledButton
                disabled={this.state.applyButtonDisabled}
                onClick={this.registerButtonClick}>
                長谷工IDを登録する
            </PrimaryStyledButton>
            <Box height={'30px'}/>
            <CenterPlainLinkStyledButton onClick={this.notRegistrationButtonClick}>
                あとで登録する
            </CenterPlainLinkStyledButton>
            <Box height={'30px'}/>
            {this.renderHasekoIdNotificationNote()}
        </>
    }
}

export default createResidentWithErrorHandlingPage(NatResidentHasekoIdRegistrationPage)

const InfosWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 7px;
  box-sizing: border-box;
  overflow: hidden;
`
const InfosContainer = styled.div`
  padding: 0 31px;
  font-size: ${FontSize.Middle};
`
const openInNewIconStyle = {
    fontSize: FontSize.Big,
    strokeWidth: '0.5px',
    verticalAlign: '-5px',
}
